import React, { useEffect } from 'react';
import {
  SignInAction,
  SignInByPhoneAction, SignInByServiceAction,
  SignInByUsernameAction,
} from '@triare/auth-redux/dist/saga/auth/signIn';
import { useNavigate } from 'react-router-dom';
import { Alert, Button } from 'antd';
import { signOut } from '@triare/auth-redux/dist/saga/auth/signOut';
import { useAuth } from '../../../../store/auth';
import Wrapper from '../Wrapper';
import store from '../../../../store';

type Values = SignInAction | SignInByUsernameAction | SignInByPhoneAction | SignInByServiceAction | null;

export interface ContentProps {
  onSubmit?: (values: Values) => void
}

export interface SignInProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any
}

export default function SignIn({ content: Content }: SignInProps) {
  const {
    user, access, authorized, signIn, OTP,
  } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authorized && (signIn.response || OTP.response)) {
      navigate('/');
    }
  }, [authorized, signIn.response, OTP.response]);

  return (
    <Wrapper>
      {user && !user.isTwoFAActive && access && !authorized ? (
        <>
          <Alert type="info" banner message="Check your email!" description="Check your email to complete 2FA" />
          <Button type="primary" onClick={() => store.dispatch(signOut())}>Sign out and try again</Button>
        </>
        /* <OTPCode
          onBack={() => store.dispatch(signOut())}
          // email={user?.email}
        /> */
      ) : (
        <Content />
      )}
    </Wrapper>
  );
}
